"use strict";

exports.__esModule = true;
exports.downloadCSVData = void 0;
var downloadCSVData = exports.downloadCSVData = function downloadCSVData(data, filename) {
  var csv = [data.headers.join(",")].concat(data.rows.map(function (r) {
    return r.join(",");
  })).join("\r\n");
  var link = document.createElement("a");
  var objectURL = URL.createObjectURL(new Blob([csv], {
    type: "text/csv;encoding:utf-8"
  }));
  link.setAttribute("href", objectURL);
  link.setAttribute("download", filename + ".csv");
  link.click();
  URL.revokeObjectURL(objectURL);
};